import { formatDate } from '../utils/authUtils';

export const playlists = [
  {
    playlist: {
      title: 'Holi Playlist',
      description: 'Suggestions for movives on holi holidays',
    },
    videos: [
      {
        _id: 'ab3babf0-1efc-4wret3qfgqasfw0b41',
        title: 'Me Before You',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Marvel',
        videoId: 'Eh993__rOxA',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Romance'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'ab3babf0-1efc-4086-aatiktasfw0b41',
        title: 'Interstellar',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Marvel',
        videoId: 'zSWdZVtXT7E',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Sci-fi'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'ab3babf0-hryjtj-aa19-4dc7easfw0b41',
        title: 'Matrix',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Marvel',
        videoId: '9ix7TUGVYIo',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Action'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'ab3babf0-qwer-4dc7easfw0b41',
        title: 'The Fault in our stars',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Marvel',
        videoId: '9ItBvH5J6ss',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Romance', 'Drama'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'ab3babf0-1sfegwertg9-4dc7easfw0b41',
        title: 'The Pursuit of Happiness',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Marvel',
        videoId: 'DMOBlEcRuw8',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Drama'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'ab3babf0-1ehe5trhr-4dc7easfw0b41',
        title: 'Theory of Everything',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Marvel',
        videoId: 'Salz7uGp72c',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Romance', 'Drama'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'ab3babfregerw6-aa19-4dc7easfw0b41',
        title: '300',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Marvel',
        videoId: 'UrIbxk7idYA',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Action', 'Drama'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'ab3babfresdfsdfsdfqew7easfw0b41',
        title: 'October',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Rising Sun Films',
        videoId: '7vracgLyJwI',
        likes: 25,
        dislikes: 2,
        views: 456,
        category: ['Romance', 'Drama'],
        uploadedAt: formatDate(),
      },
    ],
    _id: '80ecb6d2-5e4f-4439-bf36-57d8a2453c51',
  },
  {
    playlist: {
      title: 'Weekend nights',
      description: 'Friends suggested movies for weekends chill nights',
    },
    videos: [
      {
        _id: 'asdw3fgbfregerw6-aa19-4dc7easfw0b41',
        title: 'MEN IN BLACK: INTERNATIONAL',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Sony Pictures',
        videoId: 'BV-WEb2oxLk',
        likes: 9129,
        dislikes: 23,
        views: 1234230,
        category: ['Action', 'Drama'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'gergh46-aa19-4dc7easfw0b41',
        title: 'The Martian',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: '20th Century FOX',
        videoId: 'ej3ioOneTy8',
        likes: 99,
        dislikes: 0,
        views: 234,
        category: ['Action', 'Fiction'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'ngfkregerw6-aa19-4dc7easfw0b41',
        title: 'BLADE RUNNER 2049',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Warner Bros. Pictures',
        videoId: 'gCcx85zbxz4',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Action', 'Fiction'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'zxcweyregerw6-aa19-4dc7easfw0b41',
        title: 'VENOM',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Sony Pictures Entertainment',
        videoId: 'u9Mv98Gr5pY',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Action', 'Fiction'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'fgnypegerw6-aa19-4dc7easfw0b41',
        title: 'Rogue One: A Star Wars Story',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Star Wars',
        videoId: 'frdj1zb9sMY',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Action', 'Fiction'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'arghjofregerw6-aa19-4dc7easfw0b41',
        title: 'Jurassic Park',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Sony',
        videoId: 'lc0UehYemQA',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Action', 'Fiction'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'zzsxdregerw6-aa19-4dc7easfw0b41',
        title: 'Mad Max: Fury Road',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Warner Bros. Pictures',
        videoId: 'hEJnMQG9ev8',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Action', 'Fiction'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'xczxdfregerw6-aa19-4dc7easfw0b41',
        title: 'Fifty Shades Of Grey',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Universal Pictures',
        videoId: 'SfZWFDs0LxA',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Romance'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'qwe3vregerw6-aa19-4dc7easfw0b41',
        title: 'Titanic (1997)',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Sony',
        videoId: 'jUm88F3MEbQ',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Romance'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'zcewqregerw6-aa19-4dc7easfw0b41',
        title: 'PASSENGERS ',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Sony',
        videoId: '7BWWWQzTpNU',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Romance', 'Fiction'],
        uploadedAt: formatDate(),
      },
      {
        _id: 'cvbeerw6-aa19-4dc7easfw0b41',
        title: 'The Princess and the Bodyguard',
        description:
          'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
        creator: 'Reel One Entertainment',
        videoId: '5eivkIIWjXY',
        likes: 99,
        dislikes: 0,
        views: 10000,
        category: ['Romance'],
        uploadedAt: formatDate(),
      },
    ],
    _id: '80ecb6d2-5e4f-4439-bf36-57dgwed453c51',
  },
];
